/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamPermission,
    IamPermissionFromJSON,
    IamPermissionFromJSONTyped,
    IamPermissionToJSON,
} from './';

/**
 * 
 * @export
 * @interface CreateIamPermissionResponse
 */
export interface CreateIamPermissionResponse {
    /**
     * 
     * @type {IamPermission}
     * @memberof CreateIamPermissionResponse
     */
    iamPermission: IamPermission;
}

export function CreateIamPermissionResponseFromJSON(json: any): CreateIamPermissionResponse {
    return CreateIamPermissionResponseFromJSONTyped(json, false);
}

export function CreateIamPermissionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateIamPermissionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamPermission': IamPermissionFromJSON(json['iam_permission']),
    };
}

export function CreateIamPermissionResponseToJSON(value?: CreateIamPermissionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iam_permission': IamPermissionToJSON(value.iamPermission),
    };
}


